// @flow
import { createSelector } from 'reselect';

import { selectPricingInfos } from '@gandi/billing';

import { useResourceFetchOne } from '@gandi/resource/react';

import type { FetchParams } from '@gandi/resource/redux';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { accountsResource } from '../../modules/cloud/resources/accounts';
import type { Account } from '../../modules/cloud/resources/accounts';
import type { FullState } from '../../types';

export type FetchAccountParams = {
  country: string,
  currency: string,
  duration: number,
  duration_unit: 'd' | 'm' | 'y' | 'h',
  grid: string,
  headers?: { ... },
  params?: { [string]: mixed, ... },
  sharing_id: string,
};

export const selectFetchAccountParams: (
  state: FullState,
) => FetchAccountParams = createSelector(
  [selectPricingInfos],
  pricingInfos => ({
    country: pricingInfos.country,
    currency: pricingInfos.currency,
    duration_unit: 'd',
    duration: 30,
    grid: pricingInfos.grid,
    sharing_id: pricingInfos.sharingId,
  }),
);

export function useAccount(): {
  account: ?Account,
  fetchAccountParams: FetchAccountParams,
  isFailureAccount: boolean,
  isFetchingAccount: boolean,
  isForbiddenAccount: boolean,
  isLoadedAccount: boolean,
  isNotFoundAccount: boolean,
  label: string,
  shouldFetchAccount: boolean,
} {
  const fetchAccountParams = useAppSelector(selectFetchAccountParams);
  const {
    detail: account,
    isFailure: isFailureAccount,
    isFetching: isFetchingAccount,
    isForbidden: isForbiddenAccount,
    isLoaded: isLoadedAccount,
    isNotFound: isNotFoundAccount,
    label,
    shouldFetch: shouldFetchAccount,
  } = useResourceFetchOne(accountsResource, (fetchAccountParams: FetchParams));

  return {
    account,
    fetchAccountParams,
    isFailureAccount,
    isFetchingAccount,
    isForbiddenAccount,
    isLoadedAccount,
    isNotFoundAccount,
    label,
    shouldFetchAccount,
  };
}
